export type TableCellLayout = {
  rowIndex: number
  columnIndex: number
  cellWidth: 'half' | 'full'
}
export const translatePropertyLayoutString = (
  propertyLayoutString: string
): TableCellLayout => {
  const propertyLayoutRegExp = new RegExp(
    /^(\d+)(?:-(\d+))?(?:-(\d+))?(?:\:(\d+))?$/
  )
  const layout = propertyLayoutRegExp.exec(propertyLayoutString)
  if (!layout) {
    throw new Error(`Illegal property layout(=${propertyLayoutString}).`)
  }
  const rowIndex = Number(layout[2] || layout[1])
  const columnIndex = Number(layout[3] || 1)
  const maxColumnCount = Number(layout[4] || 2)

  return {
    rowIndex: rowIndex - 1,
    columnIndex: columnIndex - 1,
    cellWidth: maxColumnCount === 1 ? 'full' : 'half',
  }
}
